import React from 'react';
import { withRouter } from 'react-router-dom';

import VisuelHarmonies1Cuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/harmonies-1.jpg";
import VisuelHarmonies2Cuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/harmonies-2.jpg";
import VisuelHarmonies3Cuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/harmonies-3.jpg";
import VisuelHarmonies4Cuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/harmonies-4.jpg";
import VisuelHarmonies5Cuisine from "../visuels/Ecrans bornes/ECRANS accueil ET cuisine/harmonies-5.jpg";
import VisuelHarmonies1Sdb from "../visuels/Ecrans bornes/SDB/harmonies-1.jpg";
import VisuelHarmonies2Sdb from "../visuels/Ecrans bornes/SDB/harmonies-2.jpg";
import VisuelHarmonies3Sdb from "../visuels/Ecrans bornes/SDB/harmonies-3.jpg";

class ListeHarmoniesStyliste extends React.Component {

    visuel = "";
    piece = "";
    page = 0;

    redirectToHome = () => {
        const { history } = this.props;
        if(history) history.push('/');
    };

    redirectToHarmonieRouge = (numero) => {
        const { history } = this.props;
        if(this.page > 1)
        {
            switch (this.page) {
                case 2:
                    this.page  = 3;
                    break;
                case 3:
                    this.page = 6;
                    break;
                case 4:
                    this.page = 9;
                    break;
                case 5:
                    this.page = 12;
                    break;
            }
            numero = this.page  + numero;
        }
        if(history)
        {
            history.push('/pieces/' + this.piece + '/styliste/harmonie/' + numero );
        }
    };


    redirectToBack = () => {
        const { history } = this.props;
        if(history) history.goBack();
    };


    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }

    componentDidMount () {
    };
    redirectToPageSuivante = () => {

        const { history } = this.props;
        var pageSuivante = this.page + 1;
        history.push('/pieces/' + this.piece + '/styliste/' + pageSuivante + '/');
    };
    redirectToPagePrecedente = () => {

        const { history } = this.props;
        var pagePrecedente = this.page -1;
        history.push('/pieces/' + this.piece + '/styliste/' + pagePrecedente + '/');
    };
    pageAAfficher(page,piece)
    {
        console.log(piece);
        console.log(page);
        if(piece === "sdb")
        {
            switch (page) {
                case 1:
                    this.visuel = VisuelHarmonies1Sdb;
                    break;
                case 2:
                    this.visuel = VisuelHarmonies2Sdb;
                    break;
                case 3:
                    this.visuel = VisuelHarmonies3Sdb;
                    break;
                default:
                {
                    this.visuel = VisuelHarmonies1Sdb;
                    this.page = 1;
                }


            }
        }
        if(piece === "cuisine")
        {
            switch (page) {
                case 1:
                    this.visuel = VisuelHarmonies1Cuisine;
                    break;
                case 2:
                    this.visuel = VisuelHarmonies2Cuisine;
                    break;
                case 3:
                    this.visuel = VisuelHarmonies3Cuisine;
                    break;
                case 4:
                    this.visuel = VisuelHarmonies4Cuisine;
                    break;

                case 5:
                    this.visuel = VisuelHarmonies5Cuisine;
                    break;
                default:
                {
                    this.visuel = VisuelHarmonies1Cuisine;
                    this.page = 1;
                }


            }
        }
    }

    render() {
        const { params } = this.props.match;
        this.piece = params.piece;
        if("page" in params)
        this.page = params.page *1;

        this.pageAAfficher(this.page,this.piece);
        return  (
            <div>
                <img src={this.visuel} alt="Liste des harmonies" style={{width:1280}} useMap="#image-map"/>

                <map name="image-map">
                    <area onClick={() => this.redirectToHarmonieRouge(1)} alt="" title=""   coords=" 350,250,650,610" shape="rect"/>
                    <area onClick={() =>this.redirectToHarmonieRouge(2)} alt="" title=""   coords=" 660,250,950,610" shape="rect"/>
                    <area onClick={() =>this.redirectToHarmonieRouge(3)} alt="" title=""   coords=" 960,250,1250,610" shape="rect"/>
                    <area onClick={this.redirectToPageSuivante} alt="" title="redirectToPageSuivante" coords=" 660,630,720,680" shape="rect"/>
                    <area onClick={this.redirectToPagePrecedente} alt="" title="redirectToPagePrecedente" coords=" 570,630,620,680" shape="rect"/>
                    <area onClick={this.redirectToHome} alt="" title="Home" coords="1000,1200,890,900" shape="rect"/>
                    <area onClick={this.redirectToBack} alt="" title="Back" coords="1150,1200,1005,900" shape="rect"/>
                    <area onClick={this.redirectToInfo} alt="" title="Infos" coords="1100,1200,1250,900" shape="rect"/>
                </map>
            </div>);
    }

}

export default withRouter(ListeHarmoniesStyliste);